import type { Brand, Locale } from "@borealis/layout-express";
import { formatCurrency } from "@borealis/number-format";
import { Currency } from "@mobility-item-page/types";

export const formatPrice = (price: number, locale: Locale, brand: Brand) => {
  return formatCurrency(price, locale, Currency[brand]);
};
